import { Navigate, type RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { ImportRateLinesPage } from './features/import-export/pages/ImportRateLinesPage';
import { RateCardDetailPage } from './pages/RateCardDetailPage';
import { RateCardsPage } from './pages/RateCardsPage';
import { RATE_CARD_TABS, RATE_CARDS_TABS, rateCardsTabPath } from './rate-cards.paths';

/** The rate card screens, for the router to place inside the office shell. */
export const RATE_CARD_ROUTES: RouteObject[] = [
  { path: 'rate-cards', element: <Navigate to={rateCardsTabPath(RATE_CARDS_TABS[0])} replace /> },
  ...RATE_CARDS_TABS.map((tab) => ({ path: `rate-cards/${tab}`, element: <RateCardsPage tab={tab} /> })),
  { path: 'rate-cards/:id/lines/import', element: <ImportRateLinesPage /> },
  ...recordTabRoutes('rate-cards/:id', RATE_CARD_TABS, (tab) => <RateCardDetailPage tab={tab} />),
];
